module.exports = __webpack_public_path__ + "static/github-logo-light-65055ea8b679ddf71a49ad58c81241ed.png";